import { skipToken } from '@tanstack/react-query'
import {
  createFileRoute,
  Outlet,
  useLocation,
  useNavigate,
  useRouter,
} from '@tanstack/react-router'
import { trpc } from '@viastud/ui/lib/trpc'
import { useEffect } from 'react'

import { useAuthStore } from '@/store/auth.store'

export const Route = createFileRoute('/_student')({
  component: StudentLayout,
})

function StudentLayout() {
  const location = useLocation()
  const search = Route.useSearch()
  const navigate = useNavigate()
  const router = useRouter()
  const auth = useAuthStore()

  const { data: onboardingData, isLoading: isLoadingUserDetails } =
    trpc.user.getUserDetails.useQuery(
      auth.user && auth.role === 'STUDENT'
        ? {
            id: auth.user.id,
          }
        : skipToken
    )

  useEffect(() => {
    if ((!auth.isAuthenticated || !auth.user) && location.pathname !== '/onboarding') {
      void navigate({
        to: '/login',
        search: {
          from: location.pathname,
        },
      })
      return
    }

    if (auth.role === 'PARENT') {
      // const safeParse = z.object({ onboarded: z.boolean() }).safeParse(search)
      // const isOnboarded = !!safeParse.data?.onboarded
      // if (isOnboarded) {
      //   void navigate({ to: '/parent/settings' })
      //   return
      // }
      // void navigate({ to: '/parent' })
      // return
      auth.updateAuth({
        user: undefined,
        isAuthenticated: false,
        role: null,
      })
      return
    }

    if (auth.user && onboardingData) {
      if (auth.user.parentId !== onboardingData.parentId) {
        auth.updateAuth({
          user: { ...auth.user, parentId: onboardingData?.parentId ?? null },
          role: auth.role,
          isAuthenticated: true,
        })
      }
    }

    if (!isLoadingUserDetails && onboardingData && !onboardingData.isFinished) {
      void navigate({ to: '/auth/success' })
    }
  }, [isLoadingUserDetails, onboardingData, navigate, auth, location.pathname, search])

  const isOnboardingRoute = router.state.location.pathname === '/onboarding'

  const shouldShowLoader =
    !auth.isAuthenticated ||
    !auth.user ||
    auth.role === 'PARENT' ||
    (auth.isAuthenticated &&
      auth.user &&
      auth.role === 'STUDENT' &&
      !isOnboardingRoute &&
      isLoadingUserDetails)

  // Don't block if we're already on onboarding route
  if (shouldShowLoader && !isOnboardingRoute) {
    return (
      <div className="flex size-full items-center justify-center">
        <div className="h-10 w-10 animate-spin rounded-full border-2 border-gray-300 border-t-blue-500" />
      </div>
    )
  }

  return <Outlet />
}
